import React from 'react';

import {BrowserRouter, Routes, Route} from "react-router-dom";

import './App.css';

import Home from "./components/Home/Home";
// import Logout from "./components/Logout/Logout";
import ApplicationDetails from "./components/Home/ApplicationDetails/ApplicationDetails";
import PageNotFound from "./components/PageNotFound/PageNotFound";
import Blacklist from "./components/Blacklist/Blacklist";

function App() {

    return (
        <BrowserRouter>
            <Routes>
                {/*<Route path="/oauth2/logout" element={<Logout/>}/>*/}
                <Route path="/" element={<Home/>}/>
                <Route path="/applications/:id" element={<ApplicationDetails/>}/>
                <Route path="/blacklist" element={<Blacklist/>}/>
                <Route path="*" element={<PageNotFound/>} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
